import styled from 'styled-components';
import {Space} from 'antd';

const StyledExpenseDetailsTabFooter = styled.footer`
  align-items: center;
  background-color: ${props => props.theme.colors.neutral_1};
  border: 1px solid ${props => props.theme.colors.neutral_3};
  transform: translateY(-100%);
  justify-content: space-between;
  display: flex;
  left: 0;
  padding: 20px 24px;
  position: absolute;
  width: 100%;

  .ant-btn {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    width: calc(50% - 8px);

    &.ant-dropdown-trigger {
      width: 40px;
    }

    svg {
      transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      height: 16px;
      width: 16px;
    }

    &.ant-btn-default {
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_10};
        }
      }
      &:hover {
        svg {
          path {
            fill: ${props => props.theme.colors.primary_5};
          }
        }
      }
    }

    &.ant-btn-primary {
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_1};
        }
      }
    }

    &.expense-delete-btn {
      width: 40px;

      .ant-btn-icon {
        display: flex;
      }

      svg {
        height: 24px;
        width: 24px;
        path {
          fill: ${props => props.theme.colors.functional_danger};
        }
      }

      &:hover {
        border-color: ${props => props.theme.colors.functional_danger_d};
        svg {
          path {
            fill: ${props => props.theme.colors.functional_danger_d};
          }
        }
      }
    }
  }
`;

const StyledExpenseDetailsTabFooterSpace = styled(Space)`
  width: 100%;

  .ant-btn {
    width: 100%;
  }

  & > .ant-space-item {
    &:first-child {
      width: 100%;
    }
  }
`;

export {
  StyledExpenseDetailsTabFooter,
  StyledExpenseDetailsTabFooterSpace,
}
